import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

export class TransportRegistrationOptionsController extends AbstractStepController {

  private dialogService: DialogService;
  private nextControl = new StepControl();

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.transportOptionsValidityState) {
      this.nextControl.disabled = !contextChange.value;
    }
    if (contextChange.key === TerminalContextConstants.transportOptionsAutoSelect && contextChange.value === true) {
      this.wizardComponent.next();
    }
  }

  onRegisterToDashboardContext() {

  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('options started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });

  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const previousControl = new StepControl();
    previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
    previousControl.type = StepControlType.BUTTON_STROKED;
    previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
    previousControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.previous();
    };
    controls.push(previousControl);

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    this.nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';;
    this.nextControl.type = StepControlType.BUTTON;
    this.nextControl.iconAfterCss = 'fa-thin fa-angle-right';
    this.nextControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.next();
    };
    controls.push(this.nextControl);

    return controls;
  }
}
